import logo from "../../../../public/projects/puravankara/images/logo/logo.png";
import blubelle from "../../../../public/projects/puravankara/images/projects/blubelle.jpg";
import meraki from "../../../../public/projects/puravankara/images/projects/Meraki.jpg";
import orientgrand from "../../../../public/projects/puravankara/images/projects/OrientGrand.jpg";
import parkhill from "../../../../public/projects/puravankara/images/projects/ParkHill.jpg";
import zenium from "../../../../public/projects/puravankara/images/projects/Zenium.jpg";

//Blubelle
import overviewImage_blubelle from "../../../../public/projects/puravankara/images/blubelle/Overview/1.webp";
import bannerDesktopImage_blubelle from "../../../../public/projects/puravankara/images/blubelle/Banner/1.webp";
import bannerMobileImage_blubelle from "../../../../public/projects/puravankara/images/blubelle/Banner/2.webp";
import siteVisitBannerImage_blubelle from "../../../../public/projects/puravankara/images/blubelle/SiteVisitBanner/1.webp";
import Location_blubelle from "../../../../public/projects/puravankara/images/blubelle/Location/L1.webp";
import Hightlights_blubelle from "../../../../public/projects/puravankara/images/blubelle/Highlights/1.webp";
import image1BHK_blubelle from "../../../../public/projects/puravankara/images/blubelle/floorplan/1.webp";
import image2BHK_blubelle from "../../../../public/projects/puravankara/images/blubelle/floorplan/2.webp";
import location_blubelle from "../../../../public/projects/puravankara/images/blubelle/Overview/l.png";
import cal_blubelle from "../../../../public/projects/puravankara/images/blubelle/Overview/c.png";
import newlaunch_blubelle from "../../../../public/projects/puravankara/images/blubelle/Overview/n.png";
import g1_blubelle from "../../../../public/projects/puravankara/images/blubelle/Gallery/1.webp";
import g2_blubelle from "../../../../public/projects/puravankara/images/blubelle/Gallery/2.webp";
import g3_blubelle from "../../../../public/projects/puravankara/images/blubelle/Gallery/3.webp";
import g4_blubelle from "../../../../public/projects/puravankara/images/blubelle/Gallery/4.webp";
import g5_blubelle from "../../../../public/projects/puravankara/images/blubelle/Gallery/5.webp";

//zenium2
import overviewImage_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Overview/1.webp";
import bannerDesktopImage_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Banner/1.webp";
import bannerMobileImage_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Banner/2.webp";
import siteVisitBannerImage_zenium2 from "../../../../public/projects/puravankara/images/zenium2/SiteVisitBanner/1.webp";
import Location_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Location/L1.webp";
import Hightlights_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Highlights/1.webp";
import image1BHK_zenium2 from "../../../../public/projects/puravankara/images/zenium2/floorplan/1.webp";
import location_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Overview/l.png";
import cal_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Overview/c.png";
import newlaunch_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Overview/n.png";
import g1_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Gallery/1.webp";
import g2_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Gallery/2.webp";
import g3_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Gallery/3.webp";
import g4_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Gallery/4.webp";
import g5_zenium2 from "../../../../public/projects/puravankara/images/zenium2/Gallery/5.webp";

//Meraki
import overviewImage_meraki from "../../../../public/projects/puravankara/images/meraki/Overview/1.webp";
import bannerDesktopImage_meraki from "../../../../public/projects/puravankara/images/meraki/Banner/1.webp";
import bannerMobileImage_meraki from "../../../../public/projects/puravankara/images/meraki/Banner/2.webp";
import siteVisitBannerImage_meraki from "../../../../public/projects/puravankara/images/meraki/SiteVisitBanner/1.webp";
import Location_meraki from "../../../../public/projects/puravankara/images/meraki/Location/L1.webp";
import Hightlights_meraki from "../../../../public/projects/puravankara/images/meraki/Highlights/1.webp";
import image1BHK_meraki from "../../../../public/projects/puravankara/images/meraki/floorplan/1.webp";
import image2BHK_meraki from "../../../../public/projects/puravankara/images/meraki/floorplan/2.webp";
import location_meraki from "../../../../public/projects/puravankara/images/meraki/Overview/l.png";
import cal_meraki from "../../../../public/projects/puravankara/images/meraki/Overview/c.png";
import newlaunch_meraki from "../../../../public/projects/puravankara/images/meraki/Overview/n.png";
import g1_meraki from "../../../../public/projects/puravankara/images/meraki/Gallery/1.webp";
import g2_meraki from "../../../../public/projects/puravankara/images/meraki/Gallery/2.webp";
import g3_meraki from "../../../../public/projects/puravankara/images/meraki/Gallery/3.webp";
import g4_meraki from "../../../../public/projects/puravankara/images/meraki/Gallery/4.webp";
import g5_meraki from "../../../../public/projects/puravankara/images/meraki/Gallery/5.webp";

//Park Hill
import overviewImage_parkhill from "../../../../public/projects/puravankara/images/parkhill/Overview/1.webp";
import bannerDesktopImage_parkhill from "../../../../public/projects/puravankara/images/parkhill/Banner/1.webp";
import bannerMobileImage_parkhill from "../../../../public/projects/puravankara/images/parkhill/Banner/2.webp";
import siteVisitBannerImage_parkhill from "../../../../public/projects/puravankara/images/parkhill/SiteVisitBanner/1.webp";
import Location_parkhill from "../../../../public/projects/puravankara/images/parkhill/Location/L1.webp";
import Hightlights_parkhill from "../../../../public/projects/puravankara/images/parkhill/Highlights/1.webp";
import image1BHK_parkhill from "../../../../public/projects/puravankara/images/parkhill/floorplan/1.webp";
import location_parkhill from "../../../../public/projects/puravankara/images/parkhill/Overview/l.png";
import cal_parkhill from "../../../../public/projects/puravankara/images/parkhill/Overview/c.png";
import newlaunch_parkhill from "../../../../public/projects/puravankara/images/parkhill/Overview/n.png";
import g1_parkhill from "../../../../public/projects/puravankara/images/parkhill/Gallery/1.webp";
import g2_parkhill from "../../../../public/projects/puravankara/images/parkhill/Gallery/2.webp";
import g3_parkhill from "../../../../public/projects/puravankara/images/parkhill/Gallery/3.webp";
import g4_parkhill from "../../../../public/projects/puravankara/images/parkhill/Gallery/4.webp";
import g5_parkhill from "../../../../public/projects/puravankara/images/parkhill/Gallery/5.webp";

//Oriented Grand
import overviewImage_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Overview/1.webp";
import bannerDesktopImage_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Banner/1.webp";
import bannerMobileImage_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Banner/2.webp";
import siteVisitBannerImage_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/SiteVisitBanner/1.webp";
import Location_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Location/L1.webp";
import Hightlights_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Highlights/1.webp";
import image1BHK_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/floorplan/1.webp";
import location_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Overview/l.png";
import cal_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Overview/c.png";
import newlaunch_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Overview/n.png";
import g1_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Gallery/1.webp";
import g2_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Gallery/2.webp";
import g3_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Gallery/3.webp";
import g4_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Gallery/4.webp";
import g5_orientgrand from "../../../../public/projects/puravankara/images/orientgrand/Gallery/5.webp";

export const developersPuravankara = {
  name: `Puravankara Properties in Bengaluru `,
  properties: [
    {
      name: "Purva - Blubelle ",
      image: blubelle,
      price: "On Request",
      location: "RajajiNagar, Bengaluru",
      projectlocation: "Central Bengaluru",
      bed: "3 BHK",
      state: "Bengaluru",
      developer: "Puravankara",
      size: "1434 - 1631 sq. ft",
      url: `/puravankara-purvabluebelle-rajajinagar-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Puravankara - Zenium 2",
      image: zenium,
      price: " 1.68 Cr",
      location: "Hosahalli Bengaluru",
      projectlocation: "North Bengaluru",
      state: "Bengaluru",
      developer: "Puravankara",
      bed: "2 BR Apartments",
      size: "1034 sq.ft.",
      url: `/puravankara-purva-zenium-2-hosahalli-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Puravankara - Park Hill",
      image: parkhill,
      price: "On Request",
      location: "Bengaluru",
      projectlocation: "South Bengaluru",
      state: "Bengaluru",
      developer: "Puravankara",
      bed: "2 - 3- 4 BHK Apartments",
      size: "On Request",
      url: `/puravankara-purva-park-hill-mallasandra-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Puravankara - Orient Grand",
      image: orientgrand,
      price: "On Request",
      location: "Bengaluru",
      projectlocation: "Sudhama Nagar near Lalbagh",
      state: "Bengaluru",
      developer: "Puravankara",
      bed: "3 - 4 BHK Apartments",
      size: "On Request",
      url: ``,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
    {
      name: "Puravankara - Purva Meraki",
      image: meraki,
      price: "On Request",
      location: "HSR Layout ",
      projectlocation: "East Bengaluru",
      state: "Bengaluru",
      developer: "Puravankara",
      bed: "3 - 4 BHK Apartments",
      size: "2523 - 3696 sq.ft.",
      url: `/puravankara-purva-meraki-hsr-layout-bengaluru`,
      form: {
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        source_id: 11,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Property Station enquiry", // Add or update the subject here
        to_email: "leads@gurugram-property.com",
      },
    },
  ],
};

export const Headers = {
  logo: logo,
  data: {
    experience: "1975",
  },
  about: `Puravankara has maintained that there is just one secret to success since its founding in 1975: quality.
   This motto, together with unwavering principles, a focus on the needs of the customer, strong engineering, and openness in business dealings, has made it one of the "most preferred" real estate companies in both the residential and commercial markets.

`,
};
export const projectspurvankara = {
  blubelle: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_blubelle,
      bannerMobileImage: bannerMobileImage_blubelle,
      textOverlay: "",
      data: {
        title: "Purva Blubelle",
        subtitle: "Rajajinagar, Bengaluru",
        starting_price: "2.28 Cr",
        rerano: "PR/290323/005829",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Purva Blubelle",
      description: [
        `Purva Blubelle is the newly launched residential apartment project situated on Magadi Road in Rajajinagar, Bengaluru.

This high-rise residential complex, Purva Blubelle, is sprawled over 3.8 acres of prime property in the heart of Bengaluru, specifically in Rajajinagar on Magadi Road, and showcases the finest offerings of Puravankara’s luxury living segment. The development includes spacious 3 BHK apartments boasting luxurious amenities.

With tranquil views, abundant open spaces, and elegantly landscaped greenery surrounding Blubelle, it truly stands out as an exclusive offering.

The developer is committed to providing a high-quality living experience in the Rajajinagar, Magadi Road, West Bengaluru area through exceptional architecture and a lifestyle that complements Blubelle.

Purva Blubelle's location boasts excellent connectivity and is ideally positioned directly on Magadi Road, adjacent to the Magadi Road Metro station, at the intersection of Rajajinagar, close to the Majestic Bus station, Railway Station, Malleshwaram, Orion Mall, and near both existing and upcoming communities and amenities.

Amenities available at Purva Blubelle encompass a fully equipped clubhouse, beautifully landscaped gardens, a gym, a swimming pool, recreation areas, outdoor sports facilities, a children’s play zone, a party hall, and are meticulously designed with a strong emphasis on top-notch 24/7 security.

`,
      ],
      image: overviewImage_blubelle,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_blubelle,
          title: "2.28 Cr",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_blubelle,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_blubelle,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_blubelle,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "1434 sq. ft.",
          price: "2.28 Cr",
        },
        {
          type: "3 BHK",
          area: "1630 sq. ft.",
          price: "2.59 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "1434 sq. ft.",
        price: "2.28 Cr",
        image: image1BHK_blubelle,
      },
      {
        type: "3 BHK",
        area: "1630 sq. ft.",
        price: "2.59 Cr",
        image: image2BHK_blubelle,
      },
    ],

    highlights: {
      images: Hightlights_blubelle,
      tagline: "Highlights",
      features: [
        "Well-known Grade A Developer",
        "Close to Magadi Metro Station  ",
        "32-Story High-Rise ",
        "Metro Connectivity nearby  ",
        "Fitted with smart home technology and sustainable features such as rainwater harvesting and energy-efficient designs.",
      ],
    },

    location: {
      image: Location_blubelle,
      data: [
        {
          airport: {
            distance_time: "35.8 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "1.4 Km",
            name: "Venus International School",
          },
          railwayormetro: {
            distance_time: "23 m",
            name: "Magadi Metro Station",
          },
          hospital: {
            distance_time: "300 m",
            name: "Abhinav Hospital",
          },
          mall: {
            distance_time: "550 m",
            name: "GT World Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_blubelle },
        { image: g2_blubelle },
        { image: g3_blubelle },
        { image: g4_blubelle },
        { image: g5_blubelle },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Purva Blubelle, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Puravankara - Zenium 2",
          image: zenium,
          price: " 1.68 Cr",
          location: "Hosahalli Bengaluru",
          projectlocation: "North Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 BR Apartments",
          size: "1034 sq.ft.",
          url: `/puravankara-purva-zenium-2-hosahalli-bangalore`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Puravankara - Park Hill",
          image: parkhill,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "South Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 - 3- 4 BHK Apartments",
          size: "On Request",
          url: `/puravankara-purva-park-hill-mallasandra-bangalore`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Puravankara - Orient Grand",
          image: orientgrand,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Sudhama Nagar near Lalbagh",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
        {
          name: "Puravankara - Purva Meraki",
          image: meraki,
          price: "On Request",
          location: "HSR Layout ",
          projectlocation: "East Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "2523 - 3696 sq.ft.",
          url: `/puravankara-purva-meraki-hsr-layout-bangalore`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  zenium2: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_zenium2,
      bannerMobileImage: bannerMobileImage_zenium2,
      textOverlay: "",
      data: {
        title: "Purva Zenium 2",
        subtitle: "Hosahalli, Bengaluru",
        starting_price: "1.68 Cr",
        rerano: "PR/190129/002311",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Purva Zenium 2",
      description: [
        `2 & 3 BHK Intelligent Homes International Airport Road Situated along a rapidly developing corridor near the International Airport in North Bengaluru, Purva Celestial boasts outstanding connectivity to the entire city. The property is conveniently located near popular shopping malls, hospitals, public transport, and educational institutions.

Part of a sprawling 150-acre township in North Bengaluru's High-Growth Airport Corridor, it offers smart 2 and 3 BHK apartments outfitted with BluNex home features that enhance convenience and security.

Enjoy more than 80% open green areas, flowing water features, and natural biomes. Located merely 20 minutes from Bengaluru International Airport, it ensures easy access to schools, colleges, and medical facilities within a 5 km radius.

Purva Celestial merges modern technology with nature to provide a contemporary and comfortable living experience within a sustainable environment.
`,
      ],
      image: overviewImage_zenium2,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_zenium2,
          title: " 1.68 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_zenium2,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_zenium2,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_zenium2,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK",
          area: "1034 sq.ft.",
          price: " 1.68 Cr",
        },
      ],
    },

    floor_plan: [
      {
        type: "2 BHK",
        area: "1034 sq.ft.",
        price: " 1.68 Cr",
        image: image1BHK_zenium2,
      },
    ],

    highlights: {
      images: Hightlights_zenium2,
      tagline: "Highlights",
      features: [
        "80% open space with well-planned landscaped areas.",
        "25+ lifestyle amenities including swimming pool, amphitheatre, tennis court and party hall. ",
        "Easy connectivity with NH 44, just 3.5 km away.",
        "Easy access to Vidhyanagara Stadium, at a mere distance of 2.9 km",
        "For quality medical care, N R V Hospital is within a short distance of 3.9 km.",
      ],
    },

    location: {
      image: Location_zenium2,
      data: [
        {
          airport: {
            distance_time: "14.4 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "8.7 Km",
            name: "CMR University",
          },
          railwayormetro: {
            distance_time: "5.8 Km",
            name: "Bettahalsoor Station",
          },
          hospital: {
            distance_time: "3.8 Km",
            name: " N R V Hospital",
          },
          mall: {
            distance_time: "9.7 Km",
            name: "The Galleria Mall",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_zenium2 },
        { image: g2_zenium2 },
        { image: g3_zenium2 },
        { image: g4_zenium2 },
        { image: g5_zenium2 },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "",
      welcomeMessage:
        "Hi! I'm interested in Purva Zenium 2, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Purva - Blubelle ",
          image: blubelle,
          price: "On Request",
          location: "RajajiNagar, Bengaluru",
          projectlocation: "Central Bengaluru",
          bed: "3 BHK",
          state: "Bengaluru",
          developer: "Puravankara",
          size: "1434 - 1631 sq. ft",
          url: `/puravankara-purvabluebelle-rajajinagar-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },

        {
          name: "Puravankara - Park Hill",
          image: parkhill,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "South Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 - 3- 4 BHK Apartments",
          size: "On Request",
          url: `/puravankara-purva-park-hill-mallasandra-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Orient Grand",
          image: orientgrand,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Sudhama Nagar near Lalbagh",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Purva Meraki",
          image: meraki,
          price: "On Request",
          location: "HSR Layout ",
          projectlocation: "East Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "2523 - 3696 sq.ft.",
          url: `/puravankara-purva-meraki-hsr-layout-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  meraki: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_meraki,
      bannerMobileImage: bannerMobileImage_meraki,
      textOverlay: "",
      data: {
        title: "Purva Meraki",
        subtitle: "HSR Layout, Bengaluru",
        starting_price: "On Request",
        rerano: "PR/071022/005307",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Purva Meraki",
      description: [
        `Presenting Purva Meraki, an exclusive limited-edition creation crafted for the elite 1%. These luxury residences provide customized opulence, unmatched advantages, and meticulous design in the prime area of HSR Layout, the most sought-after neighborhood in Bengaluru. 

HSR Layout seamlessly merges traditional appeal with contemporary accessibility, located near key destinations such as the Outer Ring Road, Electronic City, and Koramangala. It is close to Bengaluru's bustling tech district as well as a range of social spots and green parks, making it perfect for those desiring an active lifestyle. 

Living at Purva Meraki combines luxury with ease. Relax in the immaculate Infinity Pool, find tranquility on the vast Yoga Deck, host events in the Rooftop Celebration Area, and unwind in the Relaxation Zone. Additional amenities include a Barbecue Pit, an Outdoor Gym, and expansive balconies that showcase stunning views from dawn to dusk.

Whether you aim to purchase or invest, the 3 & 4 BHK residences in HSR Layout, Bengaluru are designed for those who live at the pinnacle of life. Discover the essence of luxurious living with one of Bengaluru's premier builders and top real estate developers.
`,
      ],
      image: overviewImage_meraki,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_meraki,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_meraki,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_meraki,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_meraki,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2523 sq. ft.",
          price: "On Request",
        },
        {
          type: "3 BHK",
          area: "2767 sq. ft.",
          price: "On Request",
        },
        {
          type: "3 BHK",
          area: "2770 sq. ft.",
          price: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2523 sq. ft.",
        price: "On Request",
        image: image1BHK_meraki,
      },
      {
        type: "3 BHK",
        area: "2767 sq. ft.",
        price: "On Request",
        image: image2BHK_meraki,
      },
      {
        type: "3 BHK",
        area: "2770 sq. ft.",
        price: "On Request",
        image: image2BHK_meraki,
      },
    ],

    highlights: {
      images: Hightlights_meraki,
      tagline: "Highlights",
      features: [
        "Close to Nice Ring Road",
        "Located next to Ishaa Lake Front",
        "Project By The Puravankara Group",
        "Several Reputed Schools & Hospitals Within 2 Kms Radius",
        "Proximity to IT Hubs",
      ],
    },

    location: {
      image: Location_meraki,
      data: [
        {
          airport: {
            distance_time: "45.4 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "11.1 km",
            name: "Dayananda Sagar University",
          },
          railwayormetro: {
            distance_time: "15.2 km",
            name: "KSR Junction",
          },
          hospital: {
            distance_time: "600 m",
            name: " Care N Cure Hospital ",
          },
          mall: {
            distance_time: "6.5 Km",
            name: "Nexus Mall ",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_meraki },
        { image: g2_meraki },
        { image: g3_meraki },
        { image: g4_meraki },
        { image: g5_meraki },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Purva Meraki, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Purva - Blubelle ",
          image: blubelle,
          price: "On Request",
          location: "RajajiNagar, Bengaluru",
          projectlocation: "Central Bengaluru",
          bed: "3 BHK",
          state: "Bengaluru",
          developer: "Puravankara",
          size: "1434 - 1631 sq. ft",
          url: `/puravankara-purvabluebelle-rajajinagar-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Zenium 2",
          image: zenium,
          price: " 1.68 Cr",
          location: "Hosahalli Bengaluru",
          projectlocation: "North Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 BR Apartments",
          size: "1034 sq.ft.",
          url: `/puravankara-purva-zenium-2-hosahalli-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Park Hill",
          image: parkhill,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "South Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 - 3- 4 BHK Apartments",
          size: "On Request",
          url: `/puravankara-purva-park-hill-mallasandra-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Orient Grand",
          image: orientgrand,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Sudhama Nagar near Lalbagh",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  parkhill: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_parkhill,
      bannerMobileImage: bannerMobileImage_parkhill,
      textOverlay: "",
      data: {
        title: "Purva Park Hill",
        subtitle: "Kanakapura Road Bengaluru",
        starting_price: "On Request",
        rerano: "PR/220601/004946",
        payment_plan: "CLP",
        status: "Under Construction",
      },
    },
    overview: {
      heading: "Purva Park Hill",
      description: [
        `Purva Park Hill is an innovative high-rise residential project featuring lush greenery, developed by Puravankara Limited. It is conveniently situated on Kanakapura Road in South Bengaluru. This expansive 15-acre property includes 246 luxurious tri-deck apartments. A thoughtfully crafted selection of 2, 3, and 4 BHK apartments caters to the diverse needs of modern homeowners. These apartments represent the height of comfort and sophistication. The development consists of four towers, each rising 20 stories high, along with a ground floor and a basement. Ownership of Towers C and D is expected to commence in September 2025, while Towers A and B will be available in December 2026.`,
      ],
      image: overviewImage_parkhill,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: location_parkhill,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: cal_parkhill,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunch_parkhill,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_parkhill,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "807 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK",
          area: "1055 sq. ft. - 1173 sq. ft.",
          price: "On Request",
          eoiAmount: "On Request",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "807 sq. ft.",
        price: "On Request",
        image: image1BHK_parkhill,
      },

      {
        type: "3 BHK",
        area: "1055 sq. ft. - 1173 sq. ft.",
        price: "On Request",
        image: image1BHK_parkhill,
      },
    ],

    highlights: {
      images: Hightlights_parkhill,
      tagline: "Highlights",
      features: [
        "The arrival of NICE road, which is the location's main prime focus.",
        "The upcoming Vajarahalli metro station will be less than 2 kilometers away.",
        "he 60-feet Kanakpura road between Sarakki and the NICE corridor.",
        "Hospitals are within a 10-kilometer radius.",
        "80% of the space is open",
      ],
    },

    location: {
      image: Location_parkhill,
      data: [
        {
          airport: {
            distance_time: "56 Km",
            name: "Kempegowda Airport",
          },
          school: {
            distance_time: "5.6 Km",
            name: "Silicon City university",
          },
          railwayormetro: {
            distance_time: "17.2 Km",
            name: "Bengaluru City",
          },
          hospital: {
            distance_time: "8.2 Km",
            name: "Sagar Hospitals",
          },
          mall: {
            distance_time: "9.7 Km",
            name: "Royal Meenakshi Mall ",
          },
        },
      ],
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: g1_parkhill },
        { image: g2_parkhill },
        { image: g3_parkhill },
        { image: g4_parkhill },
        { image: g5_parkhill },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy lsto Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Park Hill, kindly share more details.",
    },

    faq: [
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea, `,
      },
      {
        question: "What is name of Your Company ?",
        answer: `Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat rem quaerat laborum dolorem porro cumque incidunt amet. Ea,`,
      },
    ],
    similar: {
      properties: [
        {
          name: "Purva - Blubelle ",
          image: blubelle,
          price: "On Request",
          location: "RajajiNagar, Bengaluru",
          projectlocation: "Central Bengaluru",
          bed: "3 BHK",
          state: "Bengaluru",
          developer: "Puravankara",
          size: "1434 - 1631 sq. ft",
          url: `/puravankara-purvabluebelle-rajajinagar-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Zenium 2",
          image: zenium,
          price: " 1.68 Cr",
          location: "Hosahalli Bengaluru",
          projectlocation: "North Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "2 BR Apartments",
          size: "1034 sq.ft.",
          url: `/puravankara-purva-zenium-2-hosahalli-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },

        {
          name: "Puravankara - Orient Grand",
          image: orientgrand,
          price: "On Request",
          location: "Bengaluru",
          projectlocation: "Sudhama Nagar near Lalbagh",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "On Request",
          url: ``,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
        {
          name: "Puravankara - Purva Meraki",
          image: meraki,
          price: "On Request",
          location: "HSR Layout ",
          projectlocation: "East Bengaluru",
          state: "Bengaluru",
          developer: "Puravankara",
          bed: "3 - 4 BHK Apartments",
          size: "2523 - 3696 sq.ft.",
          url: `/puravankara-purva-meraki-hsr-layout-bengaluru`,
          form: {
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            source_id: 11,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "Property Station enquiry", // Add or update the subject here
            to_email: "leads@gurugram-property.com",
          },
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
};
